import { render, staticRenderFns } from "./EditProductType.vue?vue&type=template&id=6e9c6ac4&"
import script from "./EditProductType.vue?vue&type=script&lang=js&"
export * from "./EditProductType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports